<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [parkourBackButton]="['../..']" />
    </ion-buttons>

    <ion-title>{{ 'team.teamowner-details-page.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <ng-container
      *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let teamlidContext"
    >
      @if (teamlidContext.jongereProfiel.status === 'ACTIEF') {
        <parkour-profiel-details [profiel]="teamlidContext.jongereProfiel">
          <parkour-profiel-details-afwezigheid-card
            topCardContent
            [afwezigheid]="teamlidContext.jongereProfiel.afwezigheid"
          />
        </parkour-profiel-details>
      }
    </ng-container>
  </parkour-page-layout>
</ion-content>
